import { format, isValid, parse, startOfDay } from 'date-fns';

export type SpecificDatesConfiguration = {
  always_open?: string[];
  always_closed?: string[];
};

export const specificDatesConfiguration: SpecificDatesConfiguration = {
  always_open: ['01-05-2026'],
  always_closed: [],
};

export const normalizeConfiguredDate = (value: string) => {
  const trimmedValue = value.trim();
  const supportedFormats = ['dd-MM-yyyy', 'yyyy-MM-dd', 'd.M.yyyy', 'd.M.yy'] as const;
  const parsedDate = supportedFormats
    .map(dateFormat => parse(trimmedValue, dateFormat, new Date()))
    .find(isValid);

  if (!parsedDate) {
    return null;
  }

  return format(startOfDay(parsedDate), 'yyyy-MM-dd');
};
